import React from 'react';
import { EyeIcon, ArrowRightIcon } from 'lucide-react';
export function WatchList() {
  const watchItems = ['Kann die BOOXit-Partnerschaft über die Erstproduktion hinaus skalieren und einen neuen Umsatzpfeiler für Polytec schaffen?', 'Werden ElringKlingers Werksschließungen Kunden freisetzen, die Polytec gewinnen kann?', 'Bricht Röchling sein strategisches Schweigen — und wird daraus ein neuer Wettbewerbsdruck für Polytec?', 'Wie wirken sich US-Zölle und Handelsspannungen auf Polytecs Exportgeschäft und die Wettbewerbsposition aus?'];
  return <section className="mb-16" data-id="element-103">
      <div className="flex items-center gap-3 mb-6" data-id="element-104">
        <div className="bg-tech-grey text-white p-2 rounded-lg" data-id="element-105">
          <EyeIcon className="w-5 h-5" data-id="element-106" />
        </div>
        <h2 className="font-heading text-2xl font-bold text-tech-grey" data-id="element-107">
          Was Polytec nächsten Monat beobachten sollte
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-108">
        {watchItems.map((item, index) => <div key={index} className="group bg-white rounded-xl shadow-sm border border-tech-grey-25/50 p-5 flex items-start gap-4 hover:border-passion-red hover:shadow-md transition-all duration-200 cursor-pointer" data-id="element-109">
            <div className="bg-passion-red-10 p-2 rounded-full shrink-0 mt-0.5 group-hover:bg-passion-red group-hover:text-white transition-colors duration-200" data-id="element-110">
              <ArrowRightIcon className="w-4 h-4 text-passion-red group-hover:text-white" data-id="element-111" />
            </div>
            <p className="font-body text-tech-grey-75 font-medium leading-relaxed" data-id="element-112">
              {item}
            </p>
          </div>)}
      </div>
    </section>;
}